document.addEventListener('DOMContentLoaded', function() {
  const toggles = [
    { btnId: 'toggleSearchBtn', panelId: 'searchPanel', ctaSelector: '.cta-btn--search' },
    { btnId: 'toggleIntroBtn', panelId: 'introPanel', ctaSelector: '.cta-btn--intro' }
  ];

  const panels = toggles.map(t => document.getElementById(t.panelId));
  const buttons = toggles.map(t => document.getElementById(t.btnId));

  function activatePanel(targetBtn, targetPanel) {
    panels.forEach(p => p && p.classList.remove('is-active'));
    buttons.forEach(b => b && b.classList.remove('is-active'));

    targetPanel.classList.add('is-active');
    if (targetBtn) targetBtn.classList.add('is-active');

    const entrySection = document.querySelector('.entry');
    const scrollTarget = entrySection || targetPanel;
    const header = document.querySelector('.common-header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    requestAnimationFrame(() => {
      const rect = scrollTarget.getBoundingClientRect();
      const top = window.pageYOffset + rect.top - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  toggles.forEach(({ btnId, panelId }) => {
    const btn = document.getElementById(btnId);
    const panel = document.getElementById(panelId);

    if (btn && panel) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();

        const isActive = panel.classList.contains('is-active');

        panels.forEach(p => p && p.classList.remove('is-active'));
        buttons.forEach(b => b && b.classList.remove('is-active'));

        if (!isActive) {
          panel.classList.add('is-active');
          btn.classList.add('is-active');

          setTimeout(() => {
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 150);
        }
      });
    }
  });

  document.addEventListener('click', function(e) {
    for (const { btnId, panelId, ctaSelector } of toggles) {
      if (!ctaSelector) continue;
      const cta = e.target.closest(ctaSelector);
      if (!cta) continue;

      const panel = document.getElementById(panelId);
      if (!panel) continue;

      e.preventDefault();
      activatePanel(document.getElementById(btnId), panel);
      return;
    }
  });
});